import React, { useEffect, useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./DamagesTable.scss";
import DataGrid from "../../../components/datatable/DataGrid";
import { DamagesStorage } from "../../../services/damage/DamagesStorage";
import { Damage } from "../../../services/damage/Damage";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";
import PipeDiagram from "../../../components/inspection/PipeDiagram";
import { Grid } from "@mui/material";
import { featureFlagsStorage } from "../../../services/feature-flags/FeatureFlagsStorage";
import { Flags } from "../../../generated/FeatureFlags";

interface DamagesTableProps {
  damagesStorage: DamagesStorage;
}

export default observer((props: DamagesTableProps) => {
  const showPipeDiagram = featureFlagsStorage.isFeatureEnabled(Flags.Show_Pipe_Graph);
  const { damagesStorage } = props;
  const { setCurrentTimestampById } = videoPlayerService;

  const updatePlayerState = useCallback(
    (timestampId: number) => setCurrentTimestampById(timestampId),
    [setCurrentTimestampById]
  );

  useEffect(() => {
    if (props.damagesStorage.data) {
      props.damagesStorage.data.items.forEach((d: Damage) => {
        d.videoPositionOnClick(updatePlayerState);
      });
    }
    props.damagesStorage.handleCollapse(true);
  }, [props.damagesStorage, props.damagesStorage.data, updatePlayerState]);

  return (
    <div className={`damages-container ${props.damagesStorage.isCollapsed ? "collapsed" : ""}`} style={{ marginLeft: "-30px" }}>
      {showPipeDiagram ? (
        <Grid container direction="row" spacing={0} sx={{ position: "relative", overflow: "hidden", flexWrap: "nowrap" }}>
          <Grid item sm={3} sx={{ position: "relative", left: "-30px", zIndex: 1 }}>
            <PipeDiagram
              damages={damagesStorage.data?.items || []}
              endX={115}
            />
          </Grid>
          <Grid item sm={9}>
            <DataGrid
              itemTypeKey="general.damages"
              dataGridStorage={damagesStorage}
              singleSelection
              isOnSide
              isCollapsible
            />
          </Grid>
        </Grid>
      ) : (
        <DataGrid
          itemTypeKey="general.damages"
          dataGridStorage={damagesStorage}
          singleSelection
          isOnSide
          isCollapsible
        />
      )}
    </div>
  );
});
